import { merge } from 'es-toolkit'

import Logo from 'src/components/shared/logo/logo'

import { SimpleCompactContent } from './content'
import { MainSection } from '../core/main-section'
import { LayoutSection } from '../core/layout-section'
import { HeaderSection } from '../core/header-section'
import ThemeSwitchButton from '../components/theme-switch-button'

// ----------------------------------------------------------------------

export function SimpleLayout({
  sx,
  cssVars,
  children,
  slotProps,
  layoutQuery = 'md'
}) {
  const renderHeader = () => {
    const headerSlotProps = { container: { maxWidth: false } }

    const headerSlots = {
      leftArea: <Logo />,
      rightArea: <ThemeSwitchButton />
    }

    return (
      <HeaderSection
        layoutQuery={layoutQuery}
        {...slotProps?.header}
        slots={{ ...headerSlots, ...slotProps?.header?.slots }}
        slotProps={merge(headerSlotProps, slotProps?.header?.slotProps ?? {})}
        sx={slotProps?.header?.sx}
      />
    )
  }

  const renderFooter = () => null

  const renderMain = () => {
    const { compact, ...restContentProps } = slotProps?.content ?? {}

    return (
      <MainSection {...slotProps?.main}>
        {compact ? (
          <SimpleCompactContent layoutQuery={layoutQuery} {...restContentProps}>
            {children}
          </SimpleCompactContent>
        ) : (
          children
        )}
      </MainSection>
    )
  }

  return (
    <LayoutSection
      /** **************************************
       * @Header
       *************************************** */
      headerSection={renderHeader()}
      /** **************************************
       * @Footer
       *************************************** */
      footerSection={renderFooter()}
      /** **************************************
       * @Styles
       *************************************** */
      cssVars={{ '--layout-simple-content-compact-width': '448px', ...cssVars }}
      sx={sx}
    >
      {renderMain()}
    </LayoutSection>
  )
}
